import { configureStore } from '@reduxjs/toolkit'
import themingReducer from './Slices/theming/themingSlice'

export const store = configureStore({
  reducer: {
    theming: themingReducer,
  }
})